
<template>
  <div class="home-container" :data-game="gameId">
    <div v-if="loadingConfig" class="loading-wrapper fullscreen">
      <div class="loading-image"></div>
      <p class="loading-text">内容加载中</p>
    </div>
    <div v-if="!loadingConfig && configError" class="error-wrapper fullscreen">
      <p class="error-text">404 这个页面可能去火星旅行了~</p>
      <div class="error-btn" @click="fetchGameConfig">重新加载</div>
    </div>
    <template v-if="!loadingConfig && !configError">
      <div class="left-container">
        <div class="prev-arrow" @click="changeChannelIndex(-1)"></div>
        <ul class="channels"
            ref="channels"
            @touchstart="touchmoveChannelsHandler($event)"
            @touchmove="touchmoveChannelsHandler($event)"
            @touchend="touchmoveChannelsHandler($event)">
          <li v-for="c in showChannel" class="channel" :class="{cur: c.name === curChannel}" @click="curChannel=c.name" :key="c.name">
            <img class="channel-logo" :src="c.logo" v-image-auto-height />
          </li>
        </ul>
        <div class="next-arrow" @click="changeChannelIndex(1)"></div>
      </div>
      <div class="right-container">
        <div class="nav-bar">
          <ul class="sort-btn-list">
            <li v-for="sortType in channelData.sortTypes"
              :key="sortType"
              class="sort-btn"
              :class="{active: sortType===curSort}"
              :data-sort="sortType"
              @click="curSort=sortType">
              {{sortTypeMap[sortType]}}
            </li>
          </ul>
          <form class="search-form" action="javascript:void(0)" @submit="search">
            <div class="search-ipt-container">
              <input class="search-ipt" type="search" v-model="searchStr" maxlength="30" placeholder="输入主播的ID／昵称／房间号" />
              <span class="search-close-btn" v-show="searchStr" @click="clearSearch"></span>
            </div>
            <button class="search-btn" @click="search">搜 索</button>
          </form>
        </div>
        <div v-if="!loading && !streamsError" class="stream-list-wrapper">
          <ul ref="streamList" class="stream-list" @scroll="saveScrollTop" v-fix-flex-wrap>
            <li v-for="stream in (curSort ? this[curSort + 'Streams'] : [])" :key="stream.streamId" class="stream" @click="jumpToStream(stream)">
              <div class="stream-cover">
                <div class="stream-cover-image" v-lazy:background-image="curChannel==='panda' ? 'http:' + stream.thumbnailUrl : stream.thumbnailUrl">
                  <img v-if="stream.corner" :src="stream.corner.fileUrl" :class="['pos-' + stream.corner.corner]" class="stream-cover-corner-image"/>
                </div>
                <p class="cover-shadow"></p>
              </div>
              <p class="stream-title">{{stream.streamTitle}}</p>
              <div class="stream-info">
                <p class="stream-desc">{{stream.streamDesc}}</p>
                <p class="watch-num">围观：{{stream.obNumber}}</p>
              </div>
            </li>
          </ul>
          <div v-if="!(curSort ? this[curSort + 'Streams'] : []).length" class="empty-word-wrapper">
            <p class="empty-word">这个主播正在回来的路上~</p>
          </div>
        </div>
        <div v-if="!loading && streamsError" class="error-wrapper">
          <p class="error-text">404 这个页面可能去火星旅行了~</p>
          <div class="error-btn" @click="fetchStreams">重新加载</div>
        </div>
        <div v-if="loading" class="loading-wrapper">
          <div class="loading-image"></div>
          <p class="loading-text">内容加载中</p>
        </div>
        <div v-if="!isProduction" class="demo-btn-list">
          <button class="btn" @click="$router.push('/demo-for-native')" >DEMO</button>
          <a class="btn" href="https://pes-zhibo.game.163.com">正式</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import homeMixin from '../../mixins/home'
  import { setServerTime } from "../../common"

  let isFirstTime = true

  export default {
    mixins: [homeMixin],
    data(){
      return {

      }
    },
    methods: {

    },
    created(){
      if(window.__initialState__ && isFirstTime){
        this.setGameConfig(window.__initialState__)
        setServerTime(window.__initialServerTime__)
        isFirstTime = false
      }else{
        this.fetchGameConfig()
      }
    },
  }
</script>

<style lang="scss" scoped>

  .home-container {
    flex: 1;
    height: 100%;
  }
  .left-container{
    height: .94rem;
    padding: 0 .4rem;
    flex: none;
  }
  .right-container{
    flex: auto;
    /* 修复部分浏览器在没有height时, 不能缩小元素的bug */
    height: calc(100% - .94rem);
  }
  .channels{
    flex-direction: row;
    justify-content: flex-start;
    overflow: hidden;
    position: relative;
    &.smooth-back{
      transition: all 0.3s ease-in-out;
    }
  }
  .prev-arrow, .next-arrow{
    display: none;
  }
  .channel{
    flex: none;
    width: 2.05rem;
    height: .94rem;
    align-items: center;
    justify-content: center;
    position: relative;
    &:first-child{
      margin-left: -.2rem;
    }
    &:after{
      content: '';
      width: 1px;
      height: .42rem;
      background: #a8a7a8;
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -.21rem;
    }
    &:last-child:after{
      display: none;
    }
    &.cur:before{
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -.825rem;
      width: 1.65rem;
      height: 0.06rem;
      background-color: #007aff;
      border-radius: 1rem;
    }
  }
  .channel-logo{
    width: 1.65rem;
    /* height: .62rem; */
  }
  .right-container{
    flex: 1;
    background: #f5f5f5;
    &:after{
      content: '';
      position: absolute;
      bottom: 0;
      width: 100%;
      height: .3rem;
      background: linear-gradient(to bottom, rgba(245, 245, 245, 0) 20%, rgba(245, 245, 245, 1) 80%);
    }
  }
  .nav-bar{
    height: .85rem;
    padding: 0 .4rem;
    flex-direction: row;
    align-items: center;
    position: relative;
    flex: none;
  }
  .sort-btn-list{
    flex-direction: row;
  }
  .sort-btn{
    width: 1.35rem;
    height: .4rem;
    border-radius: 0.2rem;
    border: solid 1px #8d8c8d;
    text-align: center;
    line-height: .38rem;
    margin-right: .225rem;
    color: #a0a0a0;
    &.active{
      background: #007aff;
      color: white;
      border-color: #007aff;
    }
  }
  .search-form{
    position: absolute;
    top: 50%;
    right: .4rem;
    margin-top: -.2rem;
    display: flex;
  }
  .search-ipt-container{
    flex: auto;
    margin-right: .2rem;
    position: relative;
    .search-ipt{
      width: 3.4rem;
      height: 0.4rem;
      background-color: #e5e5e5;
      border-radius: 0.2rem;
      border: solid 1px #8d8c8d;
      padding: 0 .2rem;
      padding-right: .4rem;
      line-height: .4rem;
      font-size: .2rem;
      &:focus{
        outline: none;
      }
    }
    input[type=search]::-webkit-search-cancel-button {
      display: none;
      -webkit-appearance: none;//此处就是去掉默认的小×
    }
    .search-close-btn{
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      background: url(../../assets/btn-close.png) no-repeat center center;
      display: block;
      width: .4rem;
      background-size: contain;
      margin: .04rem .01rem;
    }
  }
  .search-btn{
    flex: auto;
    font-size: 0;
    width: .35rem;
    height: .35rem;
    margin-top: .02rem;
    background: url(../../assets/icon_search.png) no-repeat center center;
    background-size: contain;
    border: none;
    padding: 0;
  }
  .stream-list-wrapper{
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    flex: auto;
  }
  .stream-list{
    flex: none;
    -webkit-overflow-scrolling: touch;
    flex-flow:row wrap;
    padding: 0 0 .2rem .4rem;
    position: relative;
  }
  .stream{
    width: 2.98rem;
    margin-right: .14rem;
    margin-bottom: .18rem;
    // height: 100%;
    &:nth-child(3n){
      margin-right: 0;
    }
  }
  .stream-cover{
    .watch-num{
      display: none;
    }
  }
  .stream-cover-image{
    width: 2.95rem;
    height: 1.68rem;
    margin-bottom: .12rem;
    background-color: #ccc;
    background-size: cover;
    position: relative;
    &[lazy="loaded"]:before{
      content: '';
      width: .8rem;
      height: .8rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -.4rem;
      margin-left: -.4rem;
      background: rgba(0, 0, 0, .4);
      border-radius: .4rem;
    }
    &[lazy="loaded"]:after{
      content: '';
      width: 0;
      height: 0;
      border-left: .3rem solid rgba(245, 245, 245, .49);
      border-top: .2rem solid transparent;
      border-bottom: .2rem solid transparent;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -.2rem;
      margin-left: -.1rem;
    }
    .stream-cover-corner-image{
      position: absolute;
      max-width: 20%;
      max-height: 30%;
      &.pos-1{
        left: 0;
        top: 0;
      }
      &.pos-2{
        right: 0;
        top: 0;
      }
      &.pos-3{
        left: 0;
        bottom: 0;
      }
      &.pos-4{
        right: 0;
        bottom: 0;
      }
    }
  }
  .stream-title{
    font-size: .18rem;
    line-height: .22rem;
    color: black;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .stream-info{
    margin-top: .05rem;
    flex: 1;
    justify-content: space-between;
    flex-direction: row;
    font-size: .15rem;
    color: #646464;
  }
</style>



// WEBPACK FOOTER //
// src/entries/ma78/home.vue